import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";
import { rootCssVariables } from "./globalCssVariables";

export { colors } from "./colors";

const palette = {
  primary: colors.primary,
  success: colors.success,
  warning: colors.warning,
  error: colors.error,
  grey: colors.grey,
  secondary: colors.secondary,
  badge: colors.badge,
  chart: colors.chart,
  utility: colors.utility,
  department: colors.department,
  highlight: colors.highlight,
  extended: colors.extended,
  global: colors.global
};

const typography = {
  fontFamily: "Roboto",
  h1: {
    fontSize: 96,
    letterSpacing: -1.5,
    fontWeight: 300
  },
  h2: {
    fontSize: 60,
    letterSpacing: -0.5,
    fontWeight: 300
  },
  h3: {
    fontSize: 48,
    letterSpacing: 0,
    fontWeight: 400
  },
  h4: {
    fontSize: 34,
    letterSpacing: 0.25,
    fontWeight: 400
  },
  h5: {
    fontSize: 24,
    letterSpacing: 0,
    fontWeight: 400
  },
  h6: {
    fontSize: 20,
    letterSpacing: 0.15,
    fontWeight: 500
  },
  subtitle1: {
    fontSize: 16,
    letterSpacing: 0.15,
    fontWeight: 400
  },
  subtitle2: {
    fontSize: 14,
    letterSpacing: 0.1,
    fontWeight: 500
  },
  body1: {
    fontSize: 16,
    letterSpacing: 0.5,
    fontWeight: 400
  },
  body2: {
    fontSize: 14,
    letterSpacing: 0.25,
    fontWeight: 400
  },
  button: {
    fontSize: 14,
    letterSpacing: 1.25,
    fontWeight: 500
  },
  caption: {
    fontSize: 14,
    letterSpacing: 0.4,
    fontWeight: 400
  },
  overline: {
    fontSize: 10,
    letterSpacing: 1.5,
    fontWeight: 400
  }
};

/* istanbul ignore next */
const theme = createTheme({
  palette,
  typography,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ":root": rootCssVariables,
        body: {
          backgroundColor: `${colors.global.appBackground} !important`
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: colors.grey[600],
          border: "4px solid transparent",
          borderRadius: "8px",
          backgroundClip: "padding-box"
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: colors.grey[300],
          border: "4px solid transparent",
          borderRadius: "8px",
          backgroundClip: "padding-box"
        },
        "*::-webkit-scrollbar": {
          width: "16px"
        },
        ".flag-dropdown": {
          backgroundColor: `${colors.utility.white} !important`
        },
        ".asterisk-highlight": {
          color: colors.error.main,
          margin: "-4px 0 0 4px"
        },
        ".exportWrapper .calender .highlight": {
          border: `1px ${colors.global.exportHighlightBorder} solid`
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === "contained" && {
            ":hover": {
              backgroundColor: palette.primary.dark,
              color: palette.primary.contrastText
            },
            ":focus": {
              color: palette.primary.contrastText,
              backgroundColor: palette.primary.dark
            }
          })
        })
      }
    }
  }
});

export default theme;
